import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AGUSegmentOption { readonly Key: string; readonly Label: string; }

/**
 * The rail's three-way toggle — the mockup's `.segrow` (jobs.html:109-112):
 * one bordered row, equal-width buttons divided by a hairline, the pressed one
 * on a 9% accent tint in the accent ink. `aria-pressed` carries the state.
 */
@Component({
    standalone: false,
    selector: 'agu-segmented',
    templateUrl: './segmented.component.html',
    styleUrl: './segmented.component.scss',
})
export class AGUSegmentedComponent {
    @Input() Options: readonly AGUSegmentOption[] = [];
    @Input() Value = '';
    @Input({ required: true }) GroupLabel!: string;
    /**
     * The id of an element that already carries this group's visible heading —
     * the rail's own `.ra-filters__label` span. When set, the group is named by
     * that element (`aria-labelledby`) and the `aria-label` is dropped: two
     * names on one element is a conflict, and pointing at the visible text is
     * the stronger of the two (it cannot drift out of sync with what is on
     * screen). The job rail wrote those label ids and nothing referenced them —
     * orphaned `id`s and a duplicated name — which is what this closes (final
     * review, finding #9). Unset, the group keeps its `aria-label`: the control
     * has no visible heading of its own to point at.
     */
    @Input() LabelledBy: string | null = null;
    @Output() ValueChange = new EventEmitter<string>();

    IsOn(option: AGUSegmentOption): boolean {
        return option.Key === this.Value;
    }

    Pick(key: string): void {
        if (key !== this.Value) this.ValueChange.emit(key);
    }
}
